import script from "./web-collection-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./web-collection-detail.vue?vue&type=script&setup=true&lang=js"

import "./web-collection-detail.vue?vue&type=style&index=0&id=07e751d1&lang=scss"

const __exports__ = script;

export default __exports__